/* Animeville/Everly product page upgrades:
   photo color swatches, "Color: name" label, color-filtered gallery, hover zoom.
   Reads /products/<handle>.js; degrades gracefully if selectors/data missing. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var handle = location.pathname.split("/products/")[1].split("/")[0].split("?")[0];
  if (!handle) return;

  var CSS = [
    "fieldset.variant-option:has(.av-swatch){display:flex;flex-wrap:wrap;gap:10px;align-items:center}",
    "fieldset.variant-option:has(.av-swatch) legend{width:100%;flex-basis:100%}",
    ".av-swatch{width:56px;min-width:56px;height:56px;padding:0!important;border-radius:10px;",
    "background-size:185%;background-position:center 28%;background-color:#fff;",
    "font-size:0!important;overflow:hidden;",
    "border:1px solid rgba(128,128,128,.45);cursor:pointer;position:relative}",
    ".av-swatch .variant-option__button-label__pill{opacity:0!important}",
    ".av-swatch:has(input:checked){outline:2px solid currentColor;outline-offset:2px}",
    ".av-swatch:has(input:focus-visible){outline:2px dashed currentColor;outline-offset:2px}",
    ".av-color-name{font-weight:600}",
    "@media (hover:hover){",
    ".av-zoom{overflow:hidden;background-repeat:no-repeat;background-color:#fff;cursor:crosshair}",
    ".av-zoom .button{cursor:crosshair}",
    ".av-zoom .product-media__image,.av-zoom img{transition:opacity .12s ease-out}",
    ".av-zoom.av-zooming img{opacity:0}",
    ".av-thumb-hide{display:none!important}",
    "}"
  ].join("");

  var product = null, colorOpt = null, colorThumb = {}, mediaColor = {}, colorKey = null;

  function ensureCss() {
    if (!document.getElementById("av-upgrades-css")) {
      var s = document.createElement("style");
      s.id = "av-upgrades-css"; s.textContent = CSS;
      document.head.appendChild(s);
    }
  }

  function buildMaps(p) {
    var opt = (p.options || []).find(function (o) { return /^colou?r$/i.test(o.name); });
    if (!opt) return;
    colorOpt = opt;
    colorKey = "option" + opt.position;
    (p.variants || []).forEach(function (v) {
      var c = v[colorKey];
      if (c && !colorThumb[c] && v.featured_media && v.featured_media.preview_image) {
        var src = v.featured_media.preview_image.src;
        colorThumb[c] = src + (src.indexOf("?") > -1 ? "&" : "?") + "width=160";
      }
    });
    var sorted = opt.values.slice().sort(function (a, b) { return b.length - a.length; });
    var tagOrder = [], generic = [];
    (p.media || []).forEach(function (m) {
      var alt = (m.alt || "");
      var c = sorted.find(function (cv) {
        return alt.toLowerCase().endsWith((" in " + cv).toLowerCase());
      });
      if (c) { mediaColor[m.id] = c; tagOrder.push(c); }
      else if (/view \d+$/i.test(alt)) generic.push(m.id);
    });
    if (tagOrder.length && generic.length && generic.length % tagOrder.length === 0) {
      var per = generic.length / tagOrder.length;
      generic.forEach(function (id, i) { mediaColor[id] = tagOrder[Math.floor(i / per)]; });
    }
    /* Fallback: uniform anchor blocks (each color's featured image
       starts an equal-size block of media, e.g. hoodies). */
    if (Object.keys(mediaColor).length < (p.media || []).length) {
      var pos = {};
      (p.media || []).forEach(function (m, i) { pos[m.id] = i; });
      var anchors = [];
      var seen = {};
      (p.variants || []).forEach(function (v) {
        var c = v[colorKey];
        if (c && !seen[c] && v.featured_media && pos[v.featured_media.id] !== undefined) {
          seen[c] = 1;
          anchors.push({ i: pos[v.featured_media.id], c: c });
        }
      });
      anchors.sort(function (a, b) { return a.i - b.i; });
      var n = opt.values.length;
      if (anchors.length === n && n > 0 && anchors[0].i === 0 &&
          (p.media || []).length % n === 0) {
        var g = (p.media || []).length / n;
        var uniform = anchors.every(function (a, k) { return a.i === k * g; });
        if (uniform) {
          (p.media || []).forEach(function (m, i) {
            if (!mediaColor[m.id]) mediaColor[m.id] = anchors[Math.floor(i / g)].c;
          });
        }
      }
    }
  }

  function colorInputs() {
    if (!colorOpt) return [];
    return Array.prototype.slice.call(
      document.querySelectorAll('input[type="radio"][name^="' + colorOpt.name + '-"]'));
  }

  function selectedColor() {
    var checked = colorInputs().find(function (i) { return i.checked; });
    return checked ? checked.value : null;
  }

  function decorateSwatches() {
    colorInputs().forEach(function (input) {
      var label = input.closest("label");
      if (!label || label.dataset.avSwatch) return;
      var thumb = colorThumb[input.value];
      if (!thumb) return;
      label.dataset.avSwatch = "1";
      label.classList.add("av-swatch");
      label.style.setProperty("background-image", 'url("' + thumb + '")', "important");
      label.style.setProperty("background-size", "185%", "important");
      label.style.setProperty("background-position", "center 28%", "important");
      label.title = input.value;
    });
  }

  function decorateLegend() {
    if (!colorOpt) return;
    var inputs = colorInputs();
    if (!inputs.length) return;
    var fs = inputs[0].closest("fieldset");
    var legend = fs && fs.querySelector("legend");
    if (!legend) return;
    var span = legend.querySelector(".av-color-name");
    if (!span) {
      span = document.createElement("span");
      span.className = "av-color-name";
      legend.appendChild(span);
    }
    var sel = selectedColor();
    span.textContent = sel ? ": " + sel : "";
  }

  function filterGallery() {
    var sel = selectedColor();
    if (!sel) return;
    var tag = document.getElementById("av-gallery-filter");
    if (!tag) {
      tag = document.createElement("style");
      tag.id = "av-gallery-filter";
      document.head.appendChild(tag);
    }
    var hideIds = Object.keys(mediaColor).filter(function (id) {
      return mediaColor[id] !== sel;
    });
    tag.textContent = hideIds.map(function (id) {
      return 'li.product-media-container:has(> .product-media[data-media-id="' + id + '"]),' +
             'slideshow-slide:has(.product-media[data-media-id="' + id + '"]),' +
             '.product-media[data-media-id="' + id + '"]{display:none!important}';
    }).join("");
  }

  function decorateZoom() {
    document.querySelectorAll("li.product-media-container, slideshow-slide.product-media-container")
      .forEach(function (el) {
        if (el.closest("product-recommendations, .product-card")) return;
        if (el.querySelector(".product-media[data-media-id]")) el.classList.add("av-zoom");
      });
  }

  function slideHiddenByFilter(slide) {
    var pm = slide.querySelector(".product-media[data-media-id]");
    if (!pm) return false;
    var c = mediaColor[pm.getAttribute("data-media-id")];
    var sel = selectedColor();
    return !!(c && sel && c !== sel);
  }

  function carouselSlides() {
    var gal = document.querySelector("media-gallery");
    if (!gal) return [];
    return Array.prototype.slice.call(
      gal.querySelectorAll("slideshow-slide.product-media-container"));
  }

  function filterThumbs() {
    var slides = carouselSlides();
    if (!slides.length) return;
    var lists = [
      document.querySelectorAll(".slideshow-controls__thumbnails button.slideshow-controls__thumbnail"),
      document.querySelectorAll(".dialog-thumbnails-list-container button.button, .dialog-thumbnails-list button.button")
    ];
    lists.forEach(function (btns) {
      if (btns.length !== slides.length) return;
      slides.forEach(function (slide, i) {
        btns[i].classList.toggle("av-thumb-hide", slideHiddenByFilter(slide));
      });
    });
  }

  function syncSlide() {
    var slides = carouselSlides();
    if (!slides.length) return;
    var btns = document.querySelectorAll(
      ".slideshow-controls__thumbnails button.slideshow-controls__thumbnail");
    if (btns.length !== slides.length) return;
    var firstVisible = -1;
    for (var i = 0; i < slides.length; i++) {
      if (!slideHiddenByFilter(slides[i])) { firstVisible = i; break; }
    }
    if (firstVisible >= 0) btns[firstVisible].click();
  }

  function decorate() {
    ensureCss();
    decorateSwatches();
    decorateLegend();
    filterGallery();
    filterThumbs();
    decorateZoom();
  }

  var zoomBound = false;
  function hiRes(img) {
    var u = img.currentSrc || img.src || "";
    if (!u) return null;
    if (/([?&])width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, "$1width=2048");
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=2048";
  }
  function bindZoom() {
    if (zoomBound || !window.matchMedia("(hover: hover)").matches) return;
    zoomBound = true;
    var active = null;
    function stop() {
      if (!active) return;
      active.classList.remove("av-zooming");
      active.style.backgroundImage = "";
      active = null;
    }
    document.addEventListener("mouseover", function (e) {
      var li = e.target && e.target.closest && e.target.closest(".av-zoom");
      if (!li || li === active) return;
      stop();
      var img = li.querySelector("img");
      if (!img) return;
      var u = hiRes(img);
      if (!u) return;
      active = li;
      var probe = new Image();
      probe.onload = function () {
        if (active !== li) return;
        /* Cap zoom so the magnified view never exceeds the source's real
           pixels on this screen (tile CSS px * devicePixelRatio). */
        var r = li.getBoundingClientRect();
        var dpr = window.devicePixelRatio || 1;
        var maxPct = Math.floor((probe.naturalWidth / (r.width * dpr)) * 100);
        var pct = Math.min(220, maxPct);
        /* If the source can't give at least a 125% truly-sharp zoom,
           don't zoom at all - never show upscaled blur. */
        if (pct < 125) { active = null; return; }
        li.style.backgroundImage = 'url("' + u + '")';
        li.style.backgroundSize = pct + "%";
        li.classList.add("av-zooming");
      };
      probe.src = u;
    }, true);
    document.addEventListener("mousemove", function (e) {
      if (!active) return;
      var r = active.getBoundingClientRect();
      var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
      active.style.backgroundPosition = x + "% " + y + "%";
    }, { passive: true });
    document.addEventListener("mouseout", function (e) {
      if (!active) return;
      var to = e.relatedTarget;
      if (to && active.contains(to)) return;
      if (to && to.closest && to.closest(".av-zoom") === active) return;
      stop();
    }, true);
  }

  var debounce;
  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(decorate, 250);
  }

  fetch("/products/" + handle + ".js")
    .then(function (r) { return r.json(); })
    .then(function (p) {
      product = p;
      buildMaps(p);
      decorate();
      bindZoom();
      document.addEventListener("change", function (e) {
        if (colorOpt && e.target && e.target.name &&
            e.target.name.indexOf(colorOpt.name + "-") === 0) {
          filterGallery();
          setTimeout(decorate, 50);
          setTimeout(function () { decorate(); syncSlide(); }, 400);
        }
      }, true);
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    })
    .catch(function () { /* leave page untouched on any failure */ });
})();
